import React from "react";
import { Card, CardContent, CardHeader, Divider } from "@mui/material";

const ClientCard: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => {
    return (
        <Card elevation={4} sx={{ maxWidth: 800, margin: "auto", padding: 2, backgroundColor: "rgb(191 219 254) ", maxHeight: '80vh', overflow: 'auto' }}>
            <CardHeader title={title} sx={{ textAlign: "center", fontSize: 20, fontWeight: "bold", color: "#027aae", padding: 2, borderRadius: 2 }} />
            <Divider />
            <CardContent sx={{ overflow: 'auto' }}>
                {children}
            </CardContent>
        </Card>
    );
};

export default ClientCard;
